import React from "react";
import PropTypes from "prop-types";
import type {ContainerFunctionComponent} from "react";
import {useMySongsLibraryConnectionLogic} from "./MySongsLibraryConnection.logic";

export const MySongsLibraryConnection: ContainerFunctionComponent = ({children}) => {
  useMySongsLibraryConnectionLogic();
  return <>{children}</>;
}

MySongsLibraryConnection.propTypes = {
  children: PropTypes.node.isRequired,
}
